import stopImg from "../../../../assets/img/stop.png";
import stopImgWebp from "../../../../assets/img/stop.webp";
import docSignImg from "../../../../assets/img/docotr-signature.png";
import docSignImgWebp from "../../../../assets/img/docotr-signature.webp";

const ImportantMessageNg = () => (
    <section id="important-message">
        <div className="container-fluid py-4">
            <div className="row align-items-center justify-content-center text-center mb-4">
                <div className="col-lg-2 col-md-3 col-4">
                    <picture>
                        <source srcSet={stopImgWebp} type="image/webp" />
                        <img className="img-fluid gg-img-stop" src={stopImg} loading="lazy" />
                    </picture>
                </div>
            </div>
            <div className="row align-items-center justify-content-center text-center">
                <div className="col-md-8 col-11">
                    <h2 className="fw-bold mb-4">If you're struggling with Type 2, you need to read this.</h2>
                    <p>Maintaining a healthy metabolism and supporting balanced energy levels can feel overwhelming. While medications may be part of your journey, some people look for additional support through natural options.</p>
                    <p>That’s why we developed <b>GG<sup>17</sup> Naturals</b>, a carefully crafted supplement made with ingredients traditionally used to <b>support overall wellness</b>, <b>insulin sensitivity</b>, and <b>metabolic function</b>.</p>
                    <p>Backed by quality standards and third-party tested, <b>GG<sup>17</sup> Naturals</b> may help support:</p>
                    <p>
                        Healthy glucose metabolism<br />
                        Insulin function within a healthy range<br />
                        Energy balance throughout the day
                    </p>
                    <p>We’re so confident you’ll love it, we offer a 90-day satisfaction guarantee.</p>
                </div>
            </div>
            <div className="row align-items-center justify-content-center text-center mt-4">
                <div className="col-xl-2 col-lg-3 col-md-4 col-sm-4 col-5">
                    <picture>
                        <source srcSet={docSignImgWebp} type="image/webp" />
                        <img className="img-fluid gg-img-signature" src={docSignImg} loading="lazy" />
                    </picture>
                </div>
            </div>
        </div>
    </section>
);

export default ImportantMessageNg;